enum AuditLogActions {
  LOGOUT = 'LOGOUT',
  LOGIN = 'LOGIN',
  DISABLE_PACK = 'DISABLE_PACK',
  ENABLE_PACK = 'ENABLE_PACK',
  CREATE_PACK = 'CREATE_PACK',
  UPDATE_PACK = 'UPDATE_PACK',
  APPLY_PACK_TO_DOOR = 'APPLY_PACK_TO_DOOR',
}
export default AuditLogActions;

export const getActionName = (action: AuditLogActions) => {
  switch (action) {
    case AuditLogActions.LOGIN:
      return 'Login';
    case AuditLogActions.LOGOUT:
      return 'Logout';
    case AuditLogActions.DISABLE_PACK:
      return 'Pack disabled';
    case AuditLogActions.ENABLE_PACK:
      return 'Pack enabled';
    case AuditLogActions.CREATE_PACK:
      return 'Pack created';
    case AuditLogActions.UPDATE_PACK:
      return 'Pack updated';
    case AuditLogActions.APPLY_PACK_TO_DOOR:
      return 'Pack applied to door';
    default:
      return action;
  }
};
